import React from "react";
import "../Skeleton/Skeleton.scss";
import "./ProductCardSkeleton.scss";

function ProductCardSkeleton() {
  return (
    <div className="product-card-skeleton" aria-hidden="true">
      <div className="product-card-skeleton__image skeleton-shimmer" />
      <div className="product-card-skeleton__line product-card-skeleton__line--title skeleton-shimmer" />
      <div className="product-card-skeleton__line skeleton-shimmer" />
      <div className="product-card-skeleton__line skeleton-shimmer" />
      <div className="product-card-skeleton__line product-card-skeleton__line--price skeleton-shimmer" />
      <div className="product-card-skeleton__button skeleton-shimmer" />
    </div>
  );
}

export default ProductCardSkeleton;
